import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot
} from '@angular/router';
import { isNull } from 'lodash';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuthState } from '~auth/states/auth.state';

import { AuthService } from '../services/auth.service';
import { LocalStorage } from '~core/services/local-storage';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private authSvc = inject(AuthService);
  private authState = inject(AuthState);
  private localStorage = inject(LocalStorage);
  private router = inject(Router);


  canActivate(route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean> {
    return this.authState.isLoggedIn$
      .pipe(
        first(isLoggedIn => !isNull(isLoggedIn)),
        map(isLoggedIn => {
          if (this.authSvc.isAuthenticated()) {
            return true;
          }

          this.authSvc.removeTokens();

          if (![ '/login', '/' ].includes(state.url)) {
            this.localStorage.setItem('redirect', state.url);
          }

          this.router.navigateByUrl('/login');

          return false;
        })
      );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): Observable<boolean> {
    return this.canActivate();
  }
}
